<template>
	<focus-lock :return-focus="true">
		<div class="popup">

			<div class="popup__content">
				<div class="popup__header">
					<h3 class="popup__heading">{{ content.heading }}</h3>
					<button
						type="button"
						class="btn--close btn--close-orange btn--no-style popup__close"
						@click="close"
					>
						<svg svg-inline="" focusable="false" role="presentation" width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path d="M15.382 12.583l9.176 9.175-2.85 2.851-9.176-9.175-9.182 9.18-2.862-2.861 9.181-9.181L.494 3.396l2.85-2.85L12.52 9.72 21.701.54l2.863 2.862z" fill="#717171" fill-rule="evenodd"/></svg>
						<div>Close</div>
					</button>
				</div>

				<div class="popup__body">
					{{ content.body }}
				</div>
			</div>

			<div class="popup-footer">
				<button
					type="button"
					class="popup-footer__button"
					@click="close"
				>
					<span>Close</span>
				</button>
			</div>

		</div>
		<div class="overlay"></div>
	</focus-lock>
</template>

<script>
// Styles
import '@/sass/components/_popup.scss';

// Components
import FocusLock from 'vue-focus-lock';

export default {
	components: {
		FocusLock
	},
	data() {
		return {
			content: this.$store.state.popupContent
		};
	},
	watch: {
		// Close popup if changing routes
		$route() {
			this.$store.commit('popupOpen', false);
			this.$store.commit('popupContent', '');
		}
	},
	methods: {
		close() {
			this.$store.commit('popupOpen', false);
			this.$store.commit('popupContent', '');
		}
	},
	mounted() {
		scroll(0, 0);
	}
};
</script>
